export function getSource(instance: any): string {
	// for class instance
	if (Reflect.has(instance, 'constructor')) return instance.constructor.name;

	// for function
	if (Reflect.has(instance, 'name')) return instance.name;

	// for other
	return 'Unknown source';
}
